import React, {FC} from "react";
import {Segmented} from "antd";

export type PublicLanguage = "hr" | "en";

// HR/EN switch shared by the public pages.
export const LanguageSwitch: FC<{value: PublicLanguage; onChange: (language: PublicLanguage) => void; label: string}> = ({
    value,
    onChange,
    label
}) => (
    <Segmented
        aria-label={label}
        value={value}
        options={[{label: "HR", value: "hr"}, {label: "EN", value: "en"}]}
        onChange={next => onChange(next as PublicLanguage)}
    />
);
